import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import type { SavingsSummaryResponse } from "@/app/(general-header)/botb-rewards/types";
import type { BOTBPassMembersData, BotbPassCompetitionsResponse, PrizeStraplineTexts } from "./membersHome.types";

export const membersHomeApi = createApi({
  reducerPath: "membersHomeApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.NEXT_PUBLIC_HOST,
    credentials: "include",
  }),
  tagTypes: ["Competitions", "Savings"],
  endpoints: build => ({
    getBotbPassCompetitions: build.query<BotbPassCompetitionsResponse, void>({
      query: () => "/umbraco/00000001/StripeSubscriptionServerSide/GetBotbPassCompetitions",
      providesTags: ["Competitions"],
    }),
    getPrizeStraplineTexts: build.query<PrizeStraplineTexts, void>({
      query: () => "/umbraco/00000001/app/GetPrizeStraplineTexts",
    }),
    getSavingsSummary: build.query<SavingsSummaryResponse, void>({
      query: () => "/umbraco/BotB/Pass/SavingsSummary",
      providesTags: ["Savings"],
    }),
    getBotbPassMembersData: build.query<BOTBPassMembersData, void>({
      query: () => "/umbraco/botb/botbdynamiccontent/GetBOTBPassMembersData",
    }),
  }),
});

export const {
  useGetBotbPassCompetitionsQuery,
  useGetPrizeStraplineTextsQuery,
  useGetSavingsSummaryQuery,
  useGetBotbPassMembersDataQuery,
} = membersHomeApi;
